import React from 'react';

export const makeOptionRenderer = (option) => (
  <>
    <div>
      <b>Make:</b> {option.label}
    </div>
    <div>
      <b>Code:</b>{' '}
      {option?.nhtsaMakeCode ? option?.nhtsaMakeCode : option.value}
    </div>
  </>
);

export const modelOptionRenderer = (option) => (
  <>
    <div>
      <b>Model:</b> {option.label}
    </div>
    <div>
      <b>Code:</b>{' '}
      {option?.nhtsaModelCode ? option?.nhtsaModelCode : option.value}
    </div>
  </>
);
